var map = {
	"./B1B2层出入口通道.mp4": 3558,
	"./B2 03电梯厅.mp4": 4159,
	"./B2 04消防电梯厅.mp4": 7126,
	"./B2栋天台消防通道1.mp4": 6087,
	"./B2栋负一楼大堂.mp4": 3649,
	"./B2栋负一楼电梯后厅3.mp4": 2285,
	"./B2栋负二楼电梯后厅3.mp4": 1733,
	"./B2栋负二楼电梯后厅4.mp4": 139,
	"./一期负一楼车库入口.mp4": 6666,
	"./侨城汇前路口.mp4": 859
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 8717;